export default "__VITE_ASSET__BNiyDJFI__"